import { render, staticRenderFns } from "./QsReportLink.vue?vue&type=template&id=34f2a959"
import script from "./QsReportLink.vue?vue&type=script&lang=ts"
export * from "./QsReportLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports